<!--
 * @Author: ljc
 * @Description: pdf报告——第十四页
 * @Date: 2022-09-27 13:21:47
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
-->
<template>
   <div class="pdfPage">
        <Headers></Headers>
        <main class="main">
            <div class="pdfPageTitle">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">Summary </span>
                </div>
                <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page9.png">
                </div>
            </div>
            <div class="summary">
                <p class="summary-txt">{{PdftStore.fromData.questionnaireInfo?.overview1}}</p>
                <p class="summary-txt">{{PdftStore.fromData.questionnaireInfo?.overviewSummary}}</p>
            </div>
            <div class="nav">
                <List :type=11  :id="'listPdfReport10'"/>
            </div>
            <div class="showcase">
                <div class="showcase-chart" v-if="PdftStore.fromData.spaceEmissionOther">
                    <Echarts :name="'page14echarts'"/>
                </div>
                <div class="showcase-grade">
                    <div class="gra_box" style="margin-top:15px">
                        <Logos :ids="'arctext3'"/>
                        <div class="logoboxtxt">
                            <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <ul class="baseInfo">
                <li>
                    <div class="baseInfo-title">Data Entered by </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.inputUser}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">Entry Time </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.inputTime}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">Report Written by </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.writeUser}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">Report Time </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.writeTime}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">Report Verified by  </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.checkUser}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">Verification Time </div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.checkTime}}</div>
                </li>
            </ul>
            <Bottoms/>
            <div class="flxed">12</div>
        </main>
        <!-- 底部 -->
        
   </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue';
import List from '../components/list.vue';
import Echarts from '../components/echarts.vue';
import Logos from '../components/logos.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page14',
    components:{Headers, Bottoms, List, Echarts, Logos},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.flxed{
    position: absolute;
    right: 20px;
    bottom: 20px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
}

.pdfPage{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .main {
        width: 100%;
        padding: 96px 130px 0 130px;
        
    }
    .summary{
        margin-top: 30px;
        &-txt {
            font-size: 16px;
            font-weight: 400;
            text-align: justify;
            color: #333333;
            line-height: 24px;
            // width: inherit;
            white-space: normal;
            // word-break: break-all;
            word-wrap: break-word;
        }
    }
    .nav {
        margin-top: 170px;
        height: 220px;
    }
    .showcase{
        width: 100%;
        height: 480px;
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 64px;
        border-bottom: 2px solid #013C89;
        &-chart {
            width: 660px;
            height: 100%;
            position: relative;
            &::before {
                content: '';
                width: 3px;
                height: calc(100% - 40px);
                position: absolute;
                right: -26px;
                top: 50%;
                transform: translateY(-50%);
                background-color: #D8D8D8;
            }
        }
        &-grade {
            width: 540px;
            height: 100%;
            display: flex;
            justify-content: center;
            .gra_box{
                .img_box{
                    width: 250px;
                    height: 85px;
                    margin: 0;
                    margin-top: 66px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            
        }
    }
    .baseInfo{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 140px;
        li {
            width: 48%;
            display: flex;
            &:nth-child(-n + 4) {
                margin-bottom: 80px;
            }
        }
        &-title {
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
            width: 350px;
        }
        &-txt {
            position: relative;
            padding: 0 6px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
            width: calc(100% - 130px);
            &::before {
                content: '';
                width: calc(100% - 20px);
                position: absolute;
                left: 0;
                bottom: -8px;
                border: 1px solid #999;
            }
        }
    }
}
.logoboxtxt{
    max-width: 240px;
    max-height: 84px;
    min-width: 240px;
    min-height: 84px;
    width: 240px;
    height: 84px;
    text-align: center;
    margin: 30px auto 0 auto;
    img{
        width: auto;
        height: 84px;
    }
}
</style>